import React, { useEffect, useState, useContext } from "react";
import { getBookmarks, toggleBookmarkAPI } from "../../utils/bookmark";
import { DataListComponent } from "../../Component/DataList/DataListComponent";
import "../SearchList/SearchComponentLatest.css";
import Header from "../../Component/UI/Header/Header";
import MetadataContext from "../../Context/metadataContext";
import useUserData from "../../Context/user/useUserData";
import loginStyles from "../../Component/UI/LoginPromptModal/LoginPromptModal.module.css";

export default function BookmarksPage() {
  const [bookmarks, setBookmarks] = useState([]);
  const [loading, setLoading] = useState(false);

  const { metadata } = useContext(MetadataContext);
  const { user, loginWithGoogle } = useUserData();

  const isGoogleUser = !!user?.avatar;

  useEffect(() => {
    const loadBookmarks = async () => {
      if (!user?.id) return;
      setLoading(true);
      const data = await getBookmarks(user.id);
      setBookmarks(data);
      setLoading(false);
    };

    loadBookmarks();
  }, [user]);

  const handleBookmarkToggle = async (item, alreadyBookmarked) => {
    if (alreadyBookmarked) {
      setBookmarks((prev) => prev.filter((b) => b._id !== item._id));
    } else {
      setBookmarks((prev) => [...prev, { ...item, bookmarked: 1 }]);
    }

    try {
      await toggleBookmarkAPI({
        userId: user?.id,
        jobId: item._id,
        alreadyBookmarked,
      });
    } catch (err) {
      console.error("Error toggling bookmark:", err);
      if (alreadyBookmarked) {
        setBookmarks((prev) => [...prev, { ...item, bookmarked: 1 }]);
      } else {
        setBookmarks((prev) => prev.filter((b) => b._id !== item._id));
      }
    }
  };

  if (!isGoogleUser) {
    return (
      <>
        <Header />
        <div className="results-section">
          <div className="results-content">
            <h2 style={{ margin: "20px 10px" }}>My Bookmarks</h2>

            <p
              style={{
                margin: "20px 10px",
                fontStyle: "italic",
                color: "#555",
              }}
            >
              You need to login with Google to view your bookmarked items.
              <button
                onClick={loginWithGoogle}
                className={loginStyles.loginBtn}
                style={{
                  marginLeft: "10px",
                  display: "inline-flex",
                  alignItems: "center",
                  padding: "12px 9px",
                  fontSize: "14px",
                }}
              >
                <svg viewBox="0 0 48 48" width="16" height="16">
                  <path
                    fill="#EA4335"
                    d="M24 9.5c3.54 0 6.71 1.22 9.21 3.6l6.85-6.85C35.9 2.38 30.47 0 24 0 14.62 0 6.51 5.38 2.56 13.22l7.98 6.19C12.43 13.72 17.74 9.5 24 9.5z"
                  />
                  <path
                    fill="#4285F4"
                    d="M46.98 24.55c0-1.57-.15-3.09-.38-4.55H24v9.02h12.94c-.58 2.96-2.26 5.48-4.78 7.18l7.73 6c4.51-4.18 7.09-10.36 7.09-17.65z"
                  />
                  <path
                    fill="#FBBC05"
                    d="M10.53 28.59c-.48-1.45-.76-2.99-.76-4.59s.27-3.14.76-4.59l-7.98-6.19C.92 16.46 0 20.12 0 24c0 3.88.92 7.54 2.56 10.78l7.97-6.19z"
                  />
                  <path
                    fill="#34A853"
                    d="M24 48c6.48 0 11.93-2.13 15.89-5.81l-7.73-6c-2.15 1.45-4.92 2.3-8.16 2.3-6.26 0-11.57-4.22-13.47-9.91l-7.98 6.19C6.51 42.62 14.62 48 24 48z"
                  />
                </svg>

                <span style={{ marginLeft: "5px" }}>Sign in with Google</span>
              </button>
            </p>
          </div>
        </div>
      </>
    );
  }

  return (
    <>
      <Header />
      <div style={{ marginTop: "20px" }}></div>

      <div className="results-section">
        <div className="results-content">
          <h2 style={{ margin: "20px 10px" }}>My Bookmarks</h2>

          {loading ? (
            <p style={{ margin: "20px 10px" }}>Loading bookmarks...</p>
          ) : bookmarks.length > 0 ? (
            <DataListComponent
              dataListView={bookmarks}
              userBookmarks={bookmarks}
              searchedKey={"Bookmarks"}
              currentPage={1}
              setCurrentPage={() => {}}
              searchLoading={false}
              resultsFields2={metadata.resultsFields2}
              onBookmarkToggle={handleBookmarkToggle}
            />
          ) : (
            <p
              style={{
                margin: "20px 10px",
                fontStyle: "italic",
                color: "#555",
              }}
            >
              No bookmarks yet. Explore and save what you like.
            </p>
          )}
        </div>
      </div>
    </>
  );
}